import { s } from "../../../../utilities/common"

export const ThreeDots = () => {
  return (
    <svg
      width={s("31px")}
      height={s("6px")}
      viewBox="0 0 31 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.4545 2.54545C25.4545 1.19318 26.5682 0 28 0C29.3523 0 30.5455 1.19318 30.5455 2.54545C30.5455 3.97727 29.3523 5.09091 28 5.09091C26.5682 5.09091 25.4545 3.97727 25.4545 2.54545ZM12.7273 2.54545C12.7273 1.19318 13.8409 0 15.2727 0C16.625 0 17.8182 1.19318 17.8182 2.54545C17.8182 3.97727 16.625 5.09091 15.2727 5.09091C13.8409 5.09091 12.7273 3.97727 12.7273 2.54545ZM5.09091 2.54545C5.09091 3.97727 3.89773 5.09091 2.54545 5.09091C1.11364 5.09091 0 3.97727 0 2.54545C0 1.19318 1.11364 0 2.54545 0C3.89773 0 5.09091 1.19318 5.09091 2.54545Z"
        fill="#DADADA"
      />
    </svg>
  )
}
